var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-chat-view tw-w-screen tw-h-screen md:tw-py-4 tw-bg-gray-300 tw-flex tw-justify-center tw-items-center"},[_c('CustomerChat',{attrs:{"modal":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }